import { ApiError } from '@community_dev/requests'
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'

import { SSOConfigResponse, getSSOConfig } from 'api/sso'
import { QUERIES } from 'constants/queries'

type UseSSOConfigProps<SelectData = SSOConfigResponse> = {
  id: string
  options?: UseQueryOptions<SSOConfigResponse, ApiError, SelectData>
}

export const useSSOConfigQuery = <SelectData = SSOConfigResponse>({
  id,
  options,
}: UseSSOConfigProps<SelectData>): UseQueryResult<SelectData, ApiError> => {
  return useQuery<SSOConfigResponse, ApiError, SelectData>({
    queryKey: [QUERIES.SSO_CONFIG, id],
    queryFn: () => getSSOConfig(id),
    enabled: Boolean(id),
    ...options,
  })
}
